<template>
    <div id="home">
        <GutenbergHome v-if="hermesAPIConfig.client === 'gutenberg'"/>
        <ILPHome v-else-if="hermesAPIConfig.client === 'ilp'"/>
        <PrintCorpHome v-else-if="hermesAPIConfig.client === 'imprimer-vos-livres'"/>
        <LaBoutiqueSoBookHome v-else-if="hermesAPIConfig.client === 'la-boutique-sobook'"/>
        <AirveyEditionsHome v-else-if="hermesAPIConfig.client === 'airvey-editions'"/>
        <ImprimBookHome v-else-if="hermesAPIConfig.client === 'imprimbook'"/>
        <DefaultHome v-else/>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import DefaultHome from "./DefaultHome/DefaultHome";
import ILPHome from "./CustomHome/ILPHome/ILPHome";
import GutenbergHome from "./CustomHome/GutenbergHome/GutenbergHome";
import PrintCorpHome from "./CustomHome/PrintCorpHome/PrintCorpHome";
import LaBoutiqueSoBookHome from "./CustomHome/LaBoutiqueSoBookHome/LaBoutiqueSoBookHome";
import AirveyEditionsHome from "@/components/Hermes/Home/CustomHome/AirveyEditionsHome/AirveyEditionsHome";
import ImprimBookHome from "./CustomHome/ImprimBookHome/ImprimBookHome";

export default {
    name: "Home",
    components: {AirveyEditionsHome, LaBoutiqueSoBookHome, PrintCorpHome, GutenbergHome, ILPHome, ImprimBookHome, DefaultHome },
    computed: {
        ...mapGetters("config", {
            hermesAPIConfig: "hermesAPI",
        }),
    },
    mounted() {
        if (this.hermesAPIConfig.client === "imprimbook") {
            this.$router.replace("/self-publishing/create-book");
        }
    },
};
</script>

<style scoped>

</style>